import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ImageSelectorOptions } from '../../../shared/components/image-selector/image-selector.interface';

interface ImageSelectorContext {
  controlName: string;
  label: string;
}

@Component({
  selector: 'form-identification-card',
  templateUrl: './identification-card.component.html',
  styleUrls: ['./identification-card.component.scss']
})
export class IdentificationCardComponent implements OnInit {
  
  public readonly imageSelectorOptions: ImageSelectorOptions = {
    maxFileSize: 6,
    thumbnailSize: {
      width: 300,
      height: 200,
    },
  };

  
  @Input() overrideIdentityCardFrontHint?: string;
  @Input() overrideIdentityCardBackHint?: string;

  @Input() public formGroup: UntypedFormGroup;
  public imageSelectorIdFront: ImageSelectorContext;
  public imageSelectorIdBack: ImageSelectorContext;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.imageSelectorIdFront = {
      controlName: 'identityCardFront',
      label: this.overrideIdentityCardFrontHint || 'patient-consent.identification.identity-card-front',
    };
    this.imageSelectorIdBack = {
      controlName: 'identityCardBack',
      label: this.overrideIdentityCardBackHint || 'patient-consent.identification.identity-card-back',
    };

    this.translateService.onLangChange
      .pipe(
        map((event) => event.lang),
        startWith(this.translateService.currentLang)
      )
      .subscribe(async (lang: any) => {
        const imgSelectorBackLabel = await lastValueFrom(
          this.translateService
            .get(this.overrideIdentityCardBackHint || 'patient-consent.identification.identity-card-back')
        );
        const imgSelectorFrontLabel = await lastValueFrom(
          this.translateService
            .get(this.overrideIdentityCardFrontHint || 'patient-consent.identification.identity-card-front')
          );

        this.imageSelectorIdFront.label = imgSelectorFrontLabel;
        this.imageSelectorIdBack.label = imgSelectorBackLabel;
      });
  }

  public getFormControlByName(name: string): UntypedFormControl {
    return this.formGroup.get(name) as UntypedFormControl;
  }

}
